import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import HeightBox from "../components/HeightBox";
import ActivityService from "../services/activityService";
import { WHITE } from "../colors";
import { CUSTOMER } from "../constants/userCategory";

export default function UserActivitiesContainer({ userId, activityType, userRole }) {
  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    activities: [],
    filteredActivities: [],
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const getPageInfo = async () => {
    setIsDataLoaded(true);
    // need to check customer or emplyee and get
    let res;
    if (userRole === CUSTOMER) {
      res = await ActivityService.getAllActivitiesOfCustomer(userId);
    } else {
      res = await ActivityService.getAllActivitiesOfEmployee(userId);
    }
    setScreenInfo({
      ...screenInfo,
      activities: res.data,
      filteredActivities: res.data,
    });
    setIsDataLoaded(false);
  };
  useEffect(() => {
    getPageInfo();
  }, []);

  useEffect(() => {
    if (activityType && activityType !== "All") {
      setScreenInfo({
        ...screenInfo,
        filteredActivities: screenInfo.activities.filter((ac) => ac.type === activityType),
      });
    } else {
      setScreenInfo({
        ...screenInfo,
        filteredActivities: screenInfo.activities,
      });
    }
  }, [activityType]);
  return (
    <div>
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table
            sx={{
              minWidth: 650,
              backgroundColor: WHITE,
            }}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead>
              <TableRow>
                <TableCell align="left">Time</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="center">Related Customer</TableCell>
                <TableCell align="center">Related Employee</TableCell>
                <TableCell align="center">Related form</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {screenInfo.filteredActivities?.map((row) => (
                <TableRow
                  key={row.id}
                  hover
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  <TableCell align="left">{new Date(row?.createdAt).toLocaleString()}</TableCell>
                  <TableCell align="center">{row?.type}</TableCell>
                  <TableCell align="center">{row?.Customer?.full_name}</TableCell>
                  <TableCell align="center">{row?.Employee?.name}</TableCell>
                  <TableCell align="center">{row?.relatedForm}</TableCell>
                  <TableCell align="center">{row?.action}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}
